/**
 * Mobile Menu Drawer with Slide Navigation
 * 移动端菜单抽屉和翻页导航
 */
(function() {
  'use strict';

  function initMobileMenu() {
    const headers = document.querySelectorAll('.mt-mega-header');
    
    headers.forEach(function(header) {
      const mobileToggle = header.querySelector('.mt-mega-header__mobile-toggle');
      const menuDrawer = header.querySelector('.mt-mega-header__mobile-menu-drawer');
      const menuOverlay = header.querySelector('.mt-mega-header__mobile-menu-overlay');
      const menuClose = header.querySelector('.mt-mega-header__mobile-menu-close');
      const menuContent = header.querySelector('.mt-mega-header__mobile-menu-content');
      const navPanels = header.querySelectorAll('.mt-mega-header__mobile-nav-panel');
      const navToggles = header.querySelectorAll('[data-mobile-nav-toggle]');
      const navBacks = header.querySelectorAll('[data-mobile-nav-back]');
      
      // 打开/关闭主菜单抽屉
      if (mobileToggle && menuDrawer) {
        mobileToggle.addEventListener('click', function() {
          const isOpen = menuDrawer.classList.contains('is-open');
          if (isOpen) {
            closeMenu();
          } else {
            openMenu();
          }
        });
      }
      
      // 关闭菜单（带关闭动画）
      function closeMenu() {
        if (!menuDrawer || !menuContent) return;
        if (!menuDrawer.classList.contains('is-open')) return;

        // 添加关闭动画状态（仍保留 is-open，让过渡正常执行）
        menuDrawer.classList.add('is-closing');
        mobileToggle.setAttribute('aria-expanded', 'false');

        const onTransitionEnd = function(e) {
          if (e.target !== menuContent) return;
          menuContent.removeEventListener('transitionend', onTransitionEnd);

          // 实际关闭抽屉
          menuDrawer.classList.remove('is-open', 'is-closing');

          // 重置 showcase-outside：隐藏所有面板
          const showcaseOut = header.querySelector('.mt-mega-header__mobile-showcase-outside');
          if (showcaseOut) {
            showcaseOut.querySelectorAll('.mt-mega-header__mobile-showcase-panel').forEach(function(p) {
              p.hidden = true;
            });
            header.querySelectorAll('[data-mobile-showcase-toggle]').forEach(function(btn) {
              btn.setAttribute('aria-expanded', 'false');
            });
          }
          // 恢复页面滚动
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.width = '';
          
          // 重置所有面板到初始状态
          navPanels.forEach(function(panel) {
            panel.classList.remove('active', 'sliding-out');
          });
          
          // 显示第一级菜单
          const level1Panel = header.querySelector('.mt-mega-header__mobile-nav-level-1');
          if (level1Panel) {
            level1Panel.classList.add('active');
          }
        };

        menuContent.addEventListener('transitionend', onTransitionEnd);
      }
      
      function openMenu() {
        if (menuDrawer) {
          // 获取导航头的实际高度并设置CSS变量
          const headerHeight = header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
          
          menuDrawer.classList.add('is-open');
          mobileToggle.setAttribute('aria-expanded', 'true');
          
          // 阻止页面滚动
          document.body.style.overflow = 'hidden';
          document.body.style.position = 'fixed';
          document.body.style.width = '100%';
          
          // 确保第一级菜单显示
          const level1Panel = header.querySelector('.mt-mega-header__mobile-nav-level-1');
          if (level1Panel) {
            navPanels.forEach(function(panel) {
              panel.classList.remove('active', 'sliding-out');
            });
            level1Panel.classList.add('active');
          }

          // 默认展开第一个导航项的 showcase 内容（仅桌面端；移动端不展开，保持「列表层级」）
          const showcaseOut = header.querySelector('.mt-mega-header__mobile-showcase-outside');
          if (showcaseOut) {
            const panels = showcaseOut.querySelectorAll('.mt-mega-header__mobile-showcase-panel');
            const toggles = header.querySelectorAll('[data-mobile-showcase-toggle]');
            const level1List = header.querySelector('.mt-mega-header__mobile-nav-level-1 .mt-mega-header__mobile-menu-list');

            panels.forEach(function(p) {
              p.hidden = true;
            });
            toggles.forEach(function(btn) {
              btn.setAttribute('aria-expanded', 'false');
            });
            if (level1List) {
              level1List.querySelectorAll('.mt-mega-header__mobile-menu-item').forEach(function(item) {
                item.classList.remove('is-active');
              });
            }

            if (window.innerWidth >= 1024) {
              const firstToggle = toggles[0];
              if (firstToggle) {
                const showcaseItem = firstToggle.getAttribute('data-showcase-item');
                const firstPanel = showcaseOut.querySelector('.mt-mega-header__mobile-showcase-panel[data-menu-item-index="' + showcaseItem + '"]');
                if (firstPanel) {
                  firstPanel.hidden = false;
                  firstToggle.setAttribute('aria-expanded', 'true');
                }
                const firstItem = firstToggle.closest('.mt-mega-header__mobile-menu-item');
                if (firstItem) firstItem.classList.add('is-active');
              }
            }
          }
        }
      }
      
      // 点击遮罩层关闭菜单
      if (menuOverlay) {
        menuOverlay.addEventListener('click', closeMenu);
      }
      
      // 点击关闭按钮关闭菜单
      if (menuClose) {
        menuClose.addEventListener('click', closeMenu);
      }
      
      // ESC键关闭菜单
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && menuDrawer && menuDrawer.classList.contains('is-open')) {
          closeMenu();
        }
      });
      
      // Level 1：在 showcase-outside 切换显示；移动端点击已展开的标题可返回列表层级
      const showcaseToggles = header.querySelectorAll('[data-mobile-showcase-toggle]');

      function restoreLevel1Label(itemIndex) {
        if (!itemIndex) return;
        const level1Btn = header.querySelector(
          '.mt-mega-header__mobile-nav-level-1 .mt-mega-header__mobile-menu-item[data-item-index="' +
            itemIndex +
            '"] .mt-mega-header__mobile-menu-link'
        );
        if (!level1Btn) return;
        const textEl = level1Btn.querySelector('.mt-mega-header__mobile-menu-link-text');
        if (!textEl) return;
        if (level1Btn.dataset.originalLabel) {
          textEl.textContent = level1Btn.dataset.originalLabel;
        }
        const selectedEl = level1Btn.querySelector('.mt-mega-header__mobile-menu-link-selected-title');
        if (selectedEl) selectedEl.remove();
        level1Btn.classList.remove('has-selected-title');
      }

      function resetLinksOnlyState(panel) {
        if (!panel) return;
        panel.classList.remove('is-showing-links-only');
        const navContent = panel.querySelector('.mt-mega-header__mobile-nav-content');
        if (navContent) {
          const selectedWrap = navContent.querySelector('[data-mobile-selected-links]');
          if (selectedWrap) {
            selectedWrap.innerHTML = '';
            selectedWrap.hidden = true;
          }
          Array.prototype.slice.call(navContent.children).forEach(function(child) {
            if (child && child.matches && child.matches('[data-mobile-selected-links]')) return;
            if (child) child.hidden = false;
          });
        }
        panel.querySelectorAll('.mt-mega-header__mobile-block').forEach(function(block) {
          block.hidden = false;
        });
        panel.querySelectorAll('[data-mobile-menu-group]').forEach(function(g) {
          g.hidden = false;
        });
        panel.querySelectorAll('[data-mobile-menu-title]').forEach(function(t) {
          t.hidden = false;
        });
        panel.querySelectorAll('[data-mobile-menu-links]').forEach(function(ul) {
          ul.hidden = true;
        });
      }

      showcaseToggles.forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          const showcaseOut = header.querySelector('.mt-mega-header__mobile-showcase-outside');
          if (!showcaseOut) return;

          const showcaseItem = toggle.getAttribute('data-showcase-item');
          if (showcaseItem == null) return;
          const targetPanelIfAny = showcaseOut.querySelector('.mt-mega-header__mobile-showcase-panel[data-menu-item-index="' + showcaseItem + '"]');

          if (isExpanded && window.innerWidth < 1024) {
            // 新增一级：若当前处于“links-only”，再次点击同一个一级菜单按钮 → 返回原 block--menus（不收起）
            if (targetPanelIfAny && targetPanelIfAny.classList.contains('is-showing-links-only')) {
              resetLinksOnlyState(targetPanelIfAny);
              restoreLevel1Label(showcaseItem);
              return;
            }

            // 否则保持原逻辑：收起，返回列表层级
            showcaseOut.querySelectorAll('.mt-mega-header__mobile-showcase-panel').forEach(function(p) {
              resetLinksOnlyState(p);
            });
            showcaseOut.querySelectorAll('.mt-mega-header__mobile-showcase-panel').forEach(function(p) {
              p.hidden = true;
            });
            header.querySelectorAll('[data-mobile-showcase-toggle]').forEach(function(btn) {
              btn.setAttribute('aria-expanded', 'false');
            });
            const level1List = header.querySelector('.mt-mega-header__mobile-nav-level-1 .mt-mega-header__mobile-menu-list');
            if (level1List) {
              level1List.querySelectorAll('.mt-mega-header__mobile-menu-item').forEach(function(item) {
                item.classList.remove('is-active');
              });
            }
            return;
          }

          const panels = showcaseOut.querySelectorAll('.mt-mega-header__mobile-showcase-panel');
          const targetPanel = showcaseOut.querySelector('.mt-mega-header__mobile-showcase-panel[data-menu-item-index="' + showcaseItem + '"]');
          panels.forEach(function(p) {
            resetLinksOnlyState(p);
            p.hidden = true;
          });
          header.querySelectorAll('[data-mobile-showcase-toggle]').forEach(function(btn) {
            btn.setAttribute('aria-expanded', 'false');
          });
          const level1List = header.querySelector('.mt-mega-header__mobile-nav-level-1 .mt-mega-header__mobile-menu-list');
          if (level1List) {
            level1List.querySelectorAll('.mt-mega-header__mobile-menu-item').forEach(function(item) {
              item.classList.remove('is-active');
            });
          }
          if (targetPanel) {
            targetPanel.hidden = false;
            toggle.setAttribute('aria-expanded', 'true');
          }
          const currentItem = toggle.closest('.mt-mega-header__mobile-menu-item');
          if (currentItem) currentItem.classList.add('is-active');
        });
      });

      // Mobile multi-menu titles: click title -> show its menu links + reflect title in Level 1 toggle label
      (function initMobileMenuTitleSelection() {
        const titleButtons = header.querySelectorAll('[data-mobile-menu-title]');
        if (!titleButtons.length) return;

        function setLevel1Label(showcasePanelEl, titleText) {
          if (!showcasePanelEl) return;
          const itemIndex = showcasePanelEl.getAttribute('data-menu-item-index');
          if (!itemIndex) return;

          const level1Btn = header.querySelector(
            '.mt-mega-header__mobile-nav-level-1 .mt-mega-header__mobile-menu-item[data-item-index="' +
              itemIndex +
              '"] .mt-mega-header__mobile-menu-link'
          );
          if (!level1Btn) return;

          const textEl = level1Btn.querySelector('.mt-mega-header__mobile-menu-link-text');
          if (textEl) {
            if (!level1Btn.dataset.originalLabel) {
              level1Btn.dataset.originalLabel = (textEl.textContent || '').trim();
            }
            // Keep original label in .mt-mega-header__mobile-menu-link-text,
            // and render selected title in a separate span for styling.
            textEl.textContent = (level1Btn.dataset.originalLabel || '').trim();

            let selectedEl = level1Btn.querySelector('.mt-mega-header__mobile-menu-link-selected-title');
            if (!selectedEl) {
              selectedEl = document.createElement('span');
              selectedEl.className = 'mt-mega-header__mobile-menu-link-selected-title';
              textEl.insertAdjacentElement('afterend', selectedEl);
            }
            selectedEl.textContent = titleText || '';
            level1Btn.classList.add('has-selected-title');
          }
        }

        function showLinksForGroup(groupEl) {
          const block = groupEl.closest('.mt-mega-header__mobile-block--menus') || groupEl.parentElement;
          if (!block) return;

          const showcasePanel = groupEl.closest('.mt-mega-header__mobile-showcase-panel');
          if (!showcasePanel) return;

          const navContent = showcasePanel.querySelector('.mt-mega-header__mobile-nav-content');
          if (!navContent) return;

          // Ensure a dedicated place to render selected links inside nav-content
          let selectedWrap = navContent.querySelector('[data-mobile-selected-links]');
          if (!selectedWrap) {
            selectedWrap = document.createElement('div');
            selectedWrap.setAttribute('data-mobile-selected-links', 'true');
            selectedWrap.hidden = true;
            navContent.appendChild(selectedWrap);
          }

          // Render selected links
          selectedWrap.innerHTML = '';
          const linksUl = groupEl.querySelector('[data-mobile-menu-links]');
          if (linksUl) {
            const clone = linksUl.cloneNode(true);
            clone.hidden = false;
            clone.removeAttribute('hidden');
            selectedWrap.appendChild(clone);
          }

          // Hide the original menus block, show the selected links in content area
          block.hidden = true;
          selectedWrap.hidden = false;

          // Also hide other blocks inside this panel (keep only selected links visible)
          showcasePanel.querySelectorAll('.mt-mega-header__mobile-block').forEach(function(b) {
            if (b === block) return;
            b.hidden = true;
          });

          showcasePanel.classList.add('is-showing-links-only');
        }

        titleButtons.forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (window.innerWidth >= 1024) return;

            const titleText = (btn.textContent || '').trim();
            const group = btn.closest('[data-mobile-menu-group]');
            if (!group) return;

            const showcasePanel = btn.closest('.mt-mega-header__mobile-showcase-panel');
            setLevel1Label(showcasePanel, titleText);
            showLinksForGroup(group);
          });
        });
      })();

      // 导航翻页：点击有下拉的菜单项（仅 Level 2/3 面板内仍用翻页）
      navToggles.forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const targetPanelId = toggle.getAttribute('data-target-panel');
          if (!targetPanelId) return;
          
          const targetPanel = document.getElementById(targetPanelId);
          if (!targetPanel) return;
          
          const currentPanel = toggle.closest('.mt-mega-header__mobile-nav-panel');
          if (!currentPanel) return;
          
          // 当前面板滑出
          currentPanel.classList.add('sliding-out');
          currentPanel.classList.remove('active');
          
          // 目标面板滑入
          setTimeout(function() {
            targetPanel.classList.add('active');
            targetPanel.classList.remove('sliding-out');
            
            // 更新标题
            const navTitle = targetPanel.querySelector('.mt-mega-header__mobile-nav-title');
            const titleText = toggle.getAttribute('data-nav-title');
            if (navTitle && titleText) {
              navTitle.textContent = titleText;
            }
          }, 50);
          
          // 更新toggle状态
          toggle.setAttribute('aria-expanded', 'true');
        });
      });
      
      // 返回按钮：返回上一级
      navBacks.forEach(function(backBtn) {
        backBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const currentPanel = backBtn.closest('.mt-mega-header__mobile-nav-panel');
          if (!currentPanel) return;
          
          const currentLevel = parseInt(currentPanel.getAttribute('data-nav-level') || '1');
          
          if (currentLevel === 2) {
            // 返回第一级
            const level1Panel = header.querySelector('.mt-mega-header__mobile-nav-level-1');
            if (level1Panel) {
              // 当前面板移出到右边（完全隐藏）
              currentPanel.classList.remove('active');
              
              setTimeout(function() {
                level1Panel.classList.add('active');
                level1Panel.classList.remove('sliding-out');
                // 重置当前面板状态
                currentPanel.classList.remove('sliding-out');
              }, 50);
            }
          } else if (currentLevel === 3) {
            // 返回第二级
            const parentPanelId = currentPanel.getAttribute('data-parent-panel');
            if (parentPanelId) {
              const parentPanel = document.getElementById(parentPanelId);
              if (parentPanel) {
                // 当前面板移出到右边（完全隐藏）
                currentPanel.classList.remove('active');
                
                setTimeout(function() {
                  parentPanel.classList.add('active');
                  parentPanel.classList.remove('sliding-out');
                  // 重置当前面板状态
                  currentPanel.classList.remove('sliding-out');
                }, 50);
              }
            }
          }
        });
      });
      
      // 窗口大小改变时关闭菜单
      window.addEventListener('resize', function() {
        if (window.innerWidth >= 1024 && menuDrawer && menuDrawer.classList.contains('is-open')) {
          closeMenu();
        }
      });
    });
  }
  
  // 初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  } else {
    initMobileMenu();
  }
})();
